import { render, staticRenderFns } from "./RbNewsRow.vue?vue&type=template&id=1089e5a8&"
import script from "./RbNewsRow.vue?vue&type=script&lang=js&"
export * from "./RbNewsRow.vue?vue&type=script&lang=js&"
import style0 from "./RbNewsRow.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports